var _globalObject$navigat, _globalObject$navigat2, _globalObject$navigat3;

import { globalObject } from '@skbkontur/global-object'; // NOTE Some checks are used from https://github.com/arasatasaygin/is.js

var platform = (((_globalObject$navigat = globalObject.navigator) == null ? void 0 : _globalObject$navigat.platform) || '').toLowerCase();
var userAgent = (((_globalObject$navigat2 = globalObject.navigator) == null ? void 0 : _globalObject$navigat2.userAgent) || '').toLowerCase();
var vendor = (((_globalObject$navigat3 = globalObject.navigator) == null ? void 0 : _globalObject$navigat3.vendor) || '').toLowerCase();
export var isMac = platform.includes('mac');
export var isWindows = platform.includes('win');
export var isSafari = /version\/(\d+).+?safari/.test(userAgent);
export var isFirefox = /(?:firefox|fxios)\/(\d+)/.test(userAgent);
export var isOpera = /(?:^opera.+?version|opr)\/(\d+)/.test(userAgent);
export var isChrome = vendor.includes('google inc') && /(?:chrome|crios)\/(\d+)/.test(userAgent) && !isOpera;
export var isEdge = userAgent.includes('edge/');
export var isIE11 = userAgent.includes('trident/');
export var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent) && globalObject.document && 'ontouchstart' in globalObject.document.documentElement;
export var isIOS = /(ip[ao]d|iphone)/gi.test(userAgent);
export var isSafari17 = isSafari && userAgent.includes('version/17');